import {
  useEffect, useReducer, useState, useMemo,
} from 'react';
import { reducer, setCanSubmit } from 'SharedComponents/hcaptcha/duck';
import {
  getCaptchaService, loadCaptchaServices, destroyCaptchaServices, CaptchaActions,
} from 'bv-services/captcha';

const useCaptchaLoader = (action, loggedIn = false) => {
  const actions = useMemo(() => {
    if (loggedIn) return [];

    switch (action) {
      case CaptchaActions.LOGIN:
        return [CaptchaActions.LOGIN, CaptchaActions.USER_LOOKUP];
      case CaptchaActions.REGISTRATION:
        return [
          CaptchaActions.REGISTRATION,
          CaptchaActions.EMAIL_VERIFICATION,
          CaptchaActions.EMAIL_VALIDATION,
        ];
      case 'HOME':
        return [
          CaptchaActions.REGISTRATION_START,
        ];
      default:
        return [action];
    }
  }, [action, loggedIn]);

  const [loading, setLoading] = useState(true);
  const [context, dispatch] = useReducer(reducer, { canSubmit: false });

  useEffect(() => {
    loadCaptchaServices(actions, { dispatch }).then(() => {
      setLoading(false);
      const captchaService = getCaptchaService(action);
      dispatch(setCanSubmit(!captchaService.isHCaptcha()));
    });

    return () => destroyCaptchaServices(actions);
  }, [action, loggedIn]);

  return [context, loading, loggedIn];
};

export default useCaptchaLoader;
